import { audioNoticeText } from "../engine/server-config";
import { useApp } from "../state/store";
import { StatusLine } from "./status-line";

/**
 * The standing notice that recording on this device will not work as expected.
 *
 * **Why this is a component and not another `say()`.** The screen status line is one slot
 * in the store, addressed by path (`use-screen-status.ts`), and a recording session writes
 * to it constantly -- mic gaps, claim warnings, "Scoring the last stretch…". A notice put
 * there is gone by the next tick, which is the same silence #124 is about. This reads the
 * store directly, so it stays up for as long as it is true and disappears by itself the
 * moment the retry in `boot.ts` lands an answer.
 *
 * **Rendered before the verbs, not during the session.** The thing worth protecting is the
 * decision to record: somebody about to start or join deserves to know before they press
 * the button, not after.
 *
 * Two things to say, and nothing otherwise (see `audioNoticeText`):
 *  - the deployment takes no audio (`accepts_audio: false`, #388). Recording is refused,
 *    so the buttons are disabled and this is the one line that says why;
 *  - the settings could not be read at all -- the fault #124 is about.
 */
export function AudioNotice() {
  const serverConfig = useApp((s) => s.serverConfig);
  const serverConfigState = useApp((s) => s.serverConfigState);
  const text = audioNoticeText({ serverConfig, serverConfigState });
  if (text === null) return null;
  return <StatusLine kind="warn">{text}</StatusLine>;
}
